import {
  AccountStatusVariant,
  PendingIdentityVerificationStatus,
  RvStatus
} from "./constants";
import { Renter, RvStatusType } from "./types";

export const getDisplayAccountStatus = (
  renter: Renter
): AccountStatusVariant => {
  if (renter.type === AccountStatusVariant.Pending) {
    if (renter.case_status === AccountStatusVariant.PendingOptIn)
      return AccountStatusVariant.PendingOptIn;

    if (renter.case_status === AccountStatusVariant.PendingOptOut)
      return AccountStatusVariant.PendingOptOut;

    if (
      [
        PendingIdentityVerificationStatus.Pending,
        PendingIdentityVerificationStatus.Rejected,
        PendingIdentityVerificationStatus.Skipped
      ].includes(renter.identity_verification_status)
    )
      return AccountStatusVariant.PendingIDV;
  }

  return renter.type as AccountStatusVariant;
};

export function getRvStatusText(status: RvStatusType | null): string {
  if (!status) return "--";
  switch (status.status) {
    case RvStatus.Verified:
    case RvStatus.PendingConfirmation:
      if (status.months_delinquency === 0) return "Paid on-time";
      else return `${status.months_delinquency} + months late`;
    default:
      return "No data";
  }
}
